import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Button, TextField, Box, Menu, MenuItem, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search'; // Icon tìm kiếm
import MenuIcon from '@mui/icons-material/Menu'; // Icon menu
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Header = ({ searchValue, setSearchValue }) => {
  const [genres, setGenres] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null); // State cho menu mobile
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Hàm gọi API để lấy danh sách thể loại
  const fetchGenres = async () => {
    try {
      const response = await axios.get('https://otruyenapi.com/v1/api/the-loai');
      setGenres(response.data.data.items);
    } catch (error) {
      console.error('Error fetching genres:', error);
    }
  };

  useEffect(() => {
    fetchGenres();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 750); // Cập nhật state khi kích thước màn hình thay đổi
    };

    // Thêm listener cho resize
    window.addEventListener('resize', handleResize);
    handleResize(); // Gọi ngay để xác định trạng thái ban đầu

    // Cleanup listener khi component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Hàm xử lý khi người dùng nhấn Enter trong ô tìm kiếm
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && searchValue.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchValue)}`); // Điều hướng đến trang kết quả tìm kiếm
      window.location.reload(); // Tải lại trang
    }
  };

  // Hàm xử lý thay đổi giá trị trong ô tìm kiếm
  const handleChange = (e) => {
    setSearchValue(e.target.value); // Cập nhật searchValue
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <div>
      <AppBar position="static" sx={{ backgroundColor: '#ffffff', boxShadow: 'none' }}>
        <Toolbar style={{ justifyContent: 'space-between' }}>
          <img
            src="/logo.png"
            alt="Logo"
            style={{ height: '70px', marginRight: '10px' }}
          />
          <TextField
            variant="outlined"
            size="small"
            placeholder="Tìm kiếm truyện..."
            value={searchValue}
            onChange={handleChange} // Gọi hàm handleChange khi thay đổi
            onKeyDown={handleKeyDown} // Gọi hàm handleKeyDown khi nhấn phím
            style={{ flexGrow: 1, maxWidth: '400px', marginLeft: '10px' }}
          />
          <Box>
            {/* Chỉ hiển thị nút Đăng Ký và Đăng Nhập khi không ở chế độ di động */}
            {!isMobile && (
              <>
                <Button color="inherit" component={Link} to="/login" style={{ marginRight: '10px', backgroundColor: '#000', color: '#fff' }}>
                  Đăng nhập
                </Button>
                <Button color="inherit" component={Link} to="/signup" style={{ backgroundColor: '#fff', color: '#000' }}>
                  Đăng ký
                </Button>
              </>
            )}
            {/* Biểu tượng menu cho chế độ di động */}
            {isMobile && (
              <IconButton onClick={handleMobileMenuOpen}>
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      <AppBar position="static" sx={{ backgroundColor: '#454545' }}>
        <Toolbar style={{ justifyContent: 'flex-start' }}>
          <Button sx={{ margin: '0 10px' }} color="inherit" component={Link} to="/">Trang Chủ</Button>
          {/* Ẩn các nút khác trong chế độ di động */}
          {!isMobile && (
            <>
              <Button sx={{ margin: '0 10px' }} color="inherit" component={Link} to="/new">Truyện Mới</Button>
              <Button sx={{ margin: '0 10px' }} color="inherit" component={Link} to="/ongoing">Đang Phát Hành</Button>
              <Button sx={{ margin: '0 10px' }} color="inherit" component={Link} to="/completed">Hoàn Thành</Button>
              <Button sx={{ margin: '0 10px' }} color="inherit" component={Link} to="/coming-soon">Sắp Ra Mắt</Button>
            </>
          )}
          <Button
            sx={{ margin: '0 10px' }}
            color="inherit"
            onClick={handleMenuOpen}
          >
            Thể Loại
          </Button>

          {/* // Menu cho thể loại */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              style: {
                maxHeight: '500px', // Giới hạn chiều cao
                overflowY: 'auto', // Cho phép cuộn
                width: 'auto', // Chiều rộng tự động
              },
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
              {genres.map((genre) => (
                <Button
                  key={genre._id}
                  color="inherit"
                  component={Link}
                  to={`/genres/${genre.slug}`}
                  onClick={handleMenuClose}
                  style={{ margin: '5px 0' }} // Thêm khoảng cách giữa các nút
                >
                  {genre.name}
                </Button>
              ))}
            </div>
          </Menu>

        </Toolbar>
      </AppBar>

      {/* Hiển thị menu cho chế độ di động khi click vào icon menu */}
      {isMobile && (
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMobileMenuClose}
          PaperProps={{
            style: {
              maxHeight: 'none',
              width: 'auto',
            },
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
            <Button color="inherit" component={Link} to="/new">Truyện Mới</Button>
            <Button color="inherit" component={Link} to="/ongoing">Đang Phát Hành</Button>
            <Button color="inherit" component={Link} to="/completed">Hoàn Thành</Button>
            <Button color="inherit" component={Link} to="/coming-soon">Sắp Ra Mắt</Button>
            <hr style={{ margin: '20px 0', border: '1px solid #ccc' }} />
            <Button color="inherit" component={Link} to="/login">Đăng nhập</Button>
            <Button color="inherit" component={Link} to="/signup">Đăng ký</Button>
          </div>
        </Menu>
      )}
    </div>
  );
};

export default Header;
